import React from "react"
import {Navigate, useLocation} from "react-router-dom"

export function PrefixPathRedirect({fromPrefix, toPrefix}: {fromPrefix: string; toPrefix: string}) {
	const location = useLocation()
	const nextPath = location.pathname.startsWith(fromPrefix)
		? `${toPrefix}${location.pathname.slice(fromPrefix.length)}`
		: location.pathname

	return <Navigate to={`${nextPath}${location.search}${location.hash}`} replace />
}
